import "./AdminNav.css";
import { NavLink } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import Avatar from "../Avatar/Avatar";

export default function AdminNav() {
  const { user, isSuperAdmin, signOut } = useAuth();

  return (
    <header className="admin-nav">
      <div className="admin-nav-bar row">
        <span className="admin-nav-brand t-eyebrow t-brand">
          Multipli Hackathon <span className="t-dimmer">· Admin</span>
        </span>

        <nav className="admin-nav-links row">
          <NavLink to="/" end className={({ isActive }) => `admin-nav-link${isActive ? " admin-nav-link-active" : ""}`}>
            Teams
          </NavLink>
          {isSuperAdmin ? (
            <NavLink to="/ops" className={({ isActive }) => `admin-nav-link${isActive ? " admin-nav-link-active" : ""}`}>
              Operations
            </NavLink>
          ) : null}
          {isSuperAdmin ? (
            <NavLink to="/activity" className={({ isActive }) => `admin-nav-link${isActive ? " admin-nav-link-active" : ""}`}>
              Activity
            </NavLink>
          ) : null}
        </nav>

        <div className="admin-nav-right row">
          {isSuperAdmin ? (
            <span className="admin-nav-role t-mono">Super admin</span>
          ) : null}
          <Avatar src={user && user.avatarUrl} name={user && user.name} size="sm" />
          <button type="button" className="admin-nav-signout t-body-sm" onClick={signOut}>
            Sign out
          </button>
        </div>
      </div>
    </header>
  );
}
